import { getAgeAssuranceVideoAskUrl } from '@/client/services/url'

import ShwLink from '@/components/ShwLink'

export default function AgeAssuranceVideoAskCTA({ action }: { action: string }) {
  return (
    <>
      We were unable to verify your age. To {action}, submit a{' '}
      <ShwLink href={getAgeAssuranceVideoAskUrl()}>VideoAsk</ShwLink> if you have not already.
      Please allow up to 2 business days for review.
    </>
  )
}
